// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/Subscription/SubscriptionModal.module.css */

.SubscriptionModal_modalOverlay__UnfN3 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.85); /* Fondo oscuro para bloquear la pantalla */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Para que quede por encima del Navbar y todo lo demás */
}

.SubscriptionModal_modalContent__VbXPl {
  background-color: white;
  padding: 2.5rem;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 10px 25px rgba(0,0,0,0.5);
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/styles/Subscription/SubscriptionModal.module.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,qCAAqC,EAAE,2CAA2C;EAClF,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,yDAAyD;AAC1E;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,uCAAuC;EACvC,kBAAkB;AACpB","sourcesContent":["/* src/styles/Subscription/SubscriptionModal.module.css */\n\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.85); /* Fondo oscuro para bloquear la pantalla */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999; /* Para que quede por encima del Navbar y todo lo demás */\n}\n\n.modalContent {\n  background-color: white;\n  padding: 2.5rem;\n  border-radius: 12px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 10px 25px rgba(0,0,0,0.5);\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `SubscriptionModal_modalOverlay__UnfN3`,
	"modalContent": `SubscriptionModal_modalContent__VbXPl`
};
export default ___CSS_LOADER_EXPORT___;
